import AutocompleteStyled from "@/components/AutocompleteStyled";
import { useZipcodes } from "@/lib/api";
import { Skeleton } from "@mui/material";

export const ZipcodeSelector = ({
  name,
  defaultValue,
  onChange,
  label,
  placeholder,
  hint,
  required = false,
  disabled = false,
  ...props
}) => {
  const { zipcodes, isLoading, isError } = useZipcodes();

  const handleSelected = (event, value) => {
    event.target.name = name;
    event.target.value = value?.id;
    if (onChange) {
      onChange(event, value);
    }
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <>
      <AutocompleteStyled
        name={name}
        label={label}
        hint={hint}
        options={zipcodes}
        placeholder={placeholder}
        required={required}
        onChange={handleSelected}
        defaultValue={defaultValue}
        getOptionLabel={(option) => `${option.zipcode} ${option.label}`}
        disabled={disabled}
      />
    </>
  );
};
